import { EMAIL_SERVICE_BASE_URL, Page, serviceFetch, serviceJson } from './mobileParityApi';

export type EmailDirection = 'INBOUND' | 'OUTBOUND';
export type EmailStatus = 'UNREAD' | 'READ' | 'SEND' | 'DELIVERED' | 'DRAFT' | 'DELETED' | string;

export type EmailRecipient = {
  id?: string;
  email: string;
};

export type Email = {
  id: string;
  title?: string;
  body?: string;
  sender?: EmailRecipient;
  recipients?: EmailRecipient[];
  cc?: EmailRecipient[];
  bcc?: EmailRecipient[];
  attachments?: unknown[];
  timestamp?: string;
  direction?: EmailDirection;
  status?: EmailStatus;
};

export type EmailPage = Page<Email>;

export async function fetchIncomingEmails(
  userId: string,
  page = 0,
  size = 20
): Promise<EmailPage> {
  return serviceJson<EmailPage>(
    `${EMAIL_SERVICE_BASE_URL}/api/v1/emails/incoming?page=${page}&size=${size}`,
    { method: 'GET', actorId: userId, acceptJson: true },
    'Failed to fetch incoming emails'
  );
}

export async function fetchOutgoingEmails(
  userId: string,
  page = 0,
  size = 20
): Promise<EmailPage> {
  return serviceJson<EmailPage>(
    `${EMAIL_SERVICE_BASE_URL}/api/v1/emails/outgoing?page=${page}&size=${size}`,
    { method: 'GET', actorId: userId, acceptJson: true },
    'Failed to fetch outgoing emails'
  );
}

export async function fetchEmailById(emailId: string, userId: string): Promise<Email> {
  return serviceJson<Email>(
    `${EMAIL_SERVICE_BASE_URL}/api/v1/emails/${encodeURIComponent(emailId)}`,
    { method: 'GET', actorId: userId, acceptJson: true },
    'Failed to fetch email'
  );
}

export async function fetchIncomingEmailsByEmail(
  email: string,
  page = 0,
  size = 20
): Promise<EmailPage> {
  return serviceJson<EmailPage>(
    `${EMAIL_SERVICE_BASE_URL}/api/v1/emails/incoming/email?email=${encodeURIComponent(email)}&page=${page}&size=${size}`,
    { method: 'GET', acceptJson: true },
    'Failed to fetch incoming emails by email'
  );
}

export async function fetchOutgoingEmailsByEmail(
  email: string,
  page = 0,
  size = 20
): Promise<EmailPage> {
  return serviceJson<EmailPage>(
    `${EMAIL_SERVICE_BASE_URL}/api/v1/emails/outgoing/email?email=${encodeURIComponent(email)}&page=${page}&size=${size}`,
    { method: 'GET', acceptJson: true },
    'Failed to fetch outgoing emails by email'
  );
}

export async function deleteEmail(emailId: string, userId: string): Promise<void> {
  await serviceFetch(
    `${EMAIL_SERVICE_BASE_URL}/api/v1/emails/${encodeURIComponent(emailId)}`,
    { method: 'DELETE', actorId: userId, json: false },
    'Failed to delete email'
  );
}

export async function updateEmailStatus(
  emailId: string,
  userId: string,
  status: 'READ' | 'UNREAD'
): Promise<void> {
  await serviceFetch(
    `${EMAIL_SERVICE_BASE_URL}/api/v1/emails/${encodeURIComponent(emailId)}`,
    {
      method: 'PUT',
      actorId: userId,
      body: JSON.stringify({ emailId, userId, status }),
    },
    'Failed to update email status'
  );
}
